export enum AttachmentTypeId {
  Image = 1,
  PDF = 2,
  Doc = 3,
  Font = 4,
}
